export const getOrderTicketsQueryKeyBase = (customerId?: number) => [
  '__getOrderTickets',
  customerId,
]

export const getOrderTicketsQueryKeyFactory = {
  active: (customerId?: number) => [...getOrderTicketsQueryKeyBase(customerId), 'active'],
  completed: (customerId?: number) => [...getOrderTicketsQueryKeyBase(customerId), 'completed'],
  ticketById: (customerId?: number, ticketId?: number) => [
    ...getOrderTicketsQueryKeyBase(customerId),
    'ticket',
    ticketId,
  ],
}
